import '@beyondtrust/btux-iconography-web';
import { localized, msg } from '@lit/localize';
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { ProductMenuItem } from '../../../types';
import productSubmenuStyles from '../product-sub-menu/product-sub-menu.styles.scss';
import moreProductsSubMenuStyles from './more-products-sub-menu.styles.scss';

export const MORE_PRODUCTS_SUB_MENU_TAG = 'spog-common-menu-more-products-sub-menu' as const;

/**
 * Element showing a customer a list
 * of more products which they do not currently
 * have enabled.
 */
@customElement(MORE_PRODUCTS_SUB_MENU_TAG)
@localized()
export class SpogMoreProductsSubMenu extends LitElement {
  static override styles = [productSubmenuStyles, moreProductsSubMenuStyles];

  @property({ type: Array })
  products!: ProductMenuItem[];

  override render() {
    const availableProducts = this.products.filter((p) => !p.isAdminApp);
    return html`
      <h2>${msg('More Products')}</h2>
      <menu>
        ${repeat(
          availableProducts,
          (product) => product.slug,
          (product) => html`
            <li>
              <a href=${product.productInformationUrl} target="_blank" rel="noopener noreferrer">
                <platform-product-icon productSlug=${product.slug}></platform-product-icon>
                ${product.name}</a
              >
            </li>
          `,
        )}
      </menu>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [MORE_PRODUCTS_SUB_MENU_TAG]: SpogMoreProductsSubMenu;
  }
}
